// ============================================
// DESKTOP MEGAMENU MODULE
// ============================================
// Obsługuje otwieranie/zamykanie megamenu na desktop
// Trigger: kliknięcie w nav-item--has-megamenu .nav-link
// Zamknięcie: kliknięcie close, kliknięcie poza, Escape

(function () {
    'use strict';

    var megamenuItems = document.querySelectorAll('.navbar__desktop .nav-item--has-megamenu');
    var allMegamenus = document.querySelectorAll('.megamenu');
    var navbar = document.querySelector('.navbar');

    if (!megamenuItems.length || !allMegamenus.length) return;

    function openMegamenu(navItem, megamenu) {
        // Close any open megamenus first
        closeAllMegamenus();

        // Negative navbar → switch to standard look while megamenu is open
        if (navbar && navbar.classList.contains('navbar--negative')) {
            navbar.classList.add('navbar--megamenu-open');
        }

        // Assign stagger indices for card animations
        var cards = megamenu.querySelectorAll('.megamenu__card');
        cards.forEach(function (card, i) {
            card.style.setProperty('--card-i', i);
        });

        var links = megamenu.querySelectorAll('.megamenu__link-card');
        links.forEach(function (link, i) {
            link.style.setProperty('--link-i', i);
        });

        navItem.classList.add('is-open');
        megamenu.classList.add('is-open');
        megamenu.setAttribute('aria-hidden', 'false');

        var button = navItem.querySelector('.nav-link');
        if (button) {
            button.setAttribute('aria-expanded', 'true');
        }
    }

    function closeMegamenu(navItem, megamenu) {
        navItem.classList.remove('is-open');
        megamenu.classList.remove('is-open');

        // Restore negative look if no megamenu remains open
        if (navbar) {
            navbar.classList.remove('navbar--megamenu-open');
        }
        megamenu.setAttribute('aria-hidden', 'true');

        var button = navItem.querySelector('.nav-link');
        if (button) {
            button.setAttribute('aria-expanded', 'false');
        }
    }

    function closeAllMegamenus() {
        megamenuItems.forEach(function (item) {
            var megamenuId = item.querySelector('.nav-link').getAttribute('data-megamenu');
            var megamenu = megamenuId ? document.getElementById(megamenuId) : null;
            if (megamenu && megamenu.classList.contains('is-open')) {
                closeMegamenu(item, megamenu);
            }
        });
    }

    // Toggle on nav-link click
    megamenuItems.forEach(function (item) {
        var button = item.querySelector('.nav-link');
        if (!button) return;

        var megamenuId = button.getAttribute('data-megamenu');
        var megamenu = megamenuId ? document.getElementById(megamenuId) : null;
        if (!megamenu) return;

        button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (item.classList.contains('is-open')) {
                closeMegamenu(item, megamenu);
            } else {
                openMegamenu(item, megamenu);
            }
        });

        // Close button inside megamenu
        var closeBtn = megamenu.querySelector('.megamenu__close');
        if (closeBtn) {
            closeBtn.addEventListener('click', function (e) {
                e.stopPropagation();
                closeMegamenu(item, megamenu);
                button.focus();
            });
        }
    });

    // Close on click outside
    document.addEventListener('click', function (e) {
        var isInsideMegamenu = e.target.closest('.megamenu');
        var isInsideTrigger = e.target.closest('.nav-item--has-megamenu');
        var isPopoverTrigger = e.target.closest('[data-popover-trigger]');
        var isInsidePopover = e.target.closest('.alert-banner--popover');

        if (!isInsideMegamenu && !isInsideTrigger && !isPopoverTrigger && !isInsidePopover) {
            closeAllMegamenus();
        }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeAllMegamenus();
        }
    });

    // Close on resize below desktop breakpoint
    window.addEventListener('resize', function () {
        if (window.innerWidth < 925) {
            closeAllMegamenus();
        }
    });
})();
